/**
 * A count is only worth showing while the surface that explains it is hidden.
 *
 * With the surface open the toggle means "close", and badging a close button
 * reads as an error rather than as progress.
 */
export function hiddenSurfaceCount(surfaceOpen: boolean, count: number): number {
  return surfaceOpen ? 0 : count;
}

function plural(count: number, word: string): string {
  return `${count} ${word}${count === 1 ? "" : "s"}`;
}

/** What the right-sidebar toggle announces, given what it will do. */
export function rightSidebarToggleLabel(input: {
  readonly panelOpen: boolean;
  readonly hiddenAgentCount: number;
}): string {
  if (input.panelOpen) return "Close right sidebar";
  if (input.hiddenAgentCount > 0) {
    return `Open right sidebar, ${plural(input.hiddenAgentCount, "agent")} working`;
  }
  return "Open right sidebar";
}

/**
 * The terminal toggle's tooltip.
 *
 * The shortcut is appended rather than replacing the message: a user who cannot
 * see the drawer needs to know work is running there more than they need the
 * key, but both fit.
 */
export function terminalToggleTooltip(input: {
  readonly hiddenRunningCount: number;
  readonly shortcutLabel: string | null | undefined;
}): string {
  const shortcut = input.shortcutLabel ? ` (${input.shortcutLabel})` : "";
  if (input.hiddenRunningCount > 0) {
    return `${plural(input.hiddenRunningCount, "running terminal")} · toggle drawer${shortcut}`;
  }
  return `Toggle terminal drawer${shortcut}`;
}

/** Whether there is any checkout context worth drawing a card for. */
export function hasThreadWorkspaceContext(input: {
  readonly context:
    | {
        readonly folderPath?: string | null;
        readonly worktreePath?: string | null;
        readonly branch?: string | null;
      }
    | null
    | undefined;
  readonly projectTitle: string | null | undefined;
}): boolean {
  return Boolean(
    input.context?.folderPath ||
    input.context?.worktreePath ||
    input.context?.branch ||
    input.projectTitle,
  );
}
